import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import "../public/assets/css/custom-styles.css";

// import Footer from "./Common/Footer";
import Header from "./Common/Header";
import Sidebar from "./Common/Sidebar";
import HomeComponent from "./Components/HomeComponent";
import WelcomeDashboard from "./Components/WelcomeDashboard";
import BookingManagementList from "./pages/BookingManagement/BookingManagementList/BookingManagementList";
import AddBooking from "./pages/BookingManagement/AddBooking/AddBooking";
import CategoryList from "./pages/CategoryManagement/CategoryList/CategoryList";
import AddCategory from "./pages/CategoryManagement/AddCategory/AddCategory";
import UpdateCategory from "./pages/CategoryManagement/UpdateCategory/UpdateCategory";
import SubCategorylist from "./pages/SubCategoryManagement/SubCategorylist/SubCategorylist";
import AddSubcategory from "./pages/SubCategoryManagement/AddSubCategory/AddSubCategory";
import UpdateSubcategory from "./pages/SubCategoryManagement/UpdateSubCategory/UpdateSubCategory";
import SubCategoryDetails from "./pages/SubCategoryManagement/SubCategoryDetails/SubCategoryDetails";
import RoleManagementList from "./pages/RoleManagement/RoleManagementList/RoleManagementList";
import AddRole from "./pages/RoleManagement/AddRole/AddRole";
import UpdateRole from "./pages/RoleManagement/UpdateRole/UpdateRole";
import SettingManagement from "./pages/SeetingManagement/SettingManagement";

import CSVLeadList from "./pages/CSVLeadManagement/CSVLeadList/CSVLeadList";
import AddCSV from "./pages/CSVLeadManagement/AddCSV/AddCSV";

import AddEmployee from "./pages/EmployeeManagement/AddEmployee/AddEmployee";
import EmployeeList from "./pages/EmployeeManagement/EmployeeList/EmployeeList";
import UpdateEmployee from "./pages/EmployeeManagement/UpdateEmployee/UpdateEmployee";
import ManufacturersAddCompanySubCategory from "./pages/ManufacturersCompanySubCategoryManagement/ManufacturersAddCompanySubCategory/ManufacturersAddCompanySubCategory";
import ManufacturersCompanySubCategorylist from "./pages/ManufacturersCompanySubCategoryManagement/ManufacturersCompanySubCategorylist/ManufacturersCompanySubCategorylist";
import UpdateManufacturersCompanySubCategory from "./pages/ManufacturersCompanySubCategoryManagement/UpdateManufacturersCompanySubCategory/UpdateManufacturersCompanySubCategory";

import Loginpage from "./pages/loginpage/loginpage";
import AddVehicleManufacturersCompany from "./pages/VehicleManufacturersCompanyManagement/AddVehicleManufacturersCompanys/AddVehicleManufacturersCompanys";
import VehicleManufacturersCompanyList from "./pages/VehicleManufacturersCompanyManagement/VehicleManufacturersCompanyList/VehicleManufacturersCompanyList";
import UpdateVehicleManufacturersCompany from "./pages/VehicleManufacturersCompanyManagement/UpdateVehicleManufacturersCompany/UpdateVehicleManufacturersCompany";
import UserManagementList from "./pages/UserManagement/UserManagementlist/UserManagementList";
import InquiriesManagement from "./pages/InquiriesManagement/InquiriesManagement";
import UpdateInquiriesManagement from "./pages/InquiriesManagement/UpdateInquiriesManagement";
import AgentMeetingLead from "./pages/AgentMeetingLead/AgentMeetingLead.jsx";
import Allenquiries from "./pages/InquiriesManagement/Allenquiries";
import UserDetails from "./pages/UserManagement/UserDetails/UserDetails";
import ManageDeleteRequests from "./pages/UserManagement/ManageDeleteRequests/ManageDeleteRequests";
import AssignAgentPage from "./pages/UserManagement/ManageDeleteRequests/AssignAgentPage";
import AdminProfile from "./pages/AdminProfile/AdminProfile";

import HeaderList from "./pages/HomeManagement/HeaderManagement/HeaderList/HeaderList";
import UpdateHeader from "./pages/HomeManagement/HeaderManagement/UpdateHeader/UpdateHeader";
import AddHeader from "./pages/HomeManagement/HeaderManagement/AddHeader/AddHeader";
import AddHeroSlider from "./pages/HomeManagement/HeroSliderManagement/AddHeroSlider/AddHeroSlider";
import HeroSliderList from "./pages/HomeManagement/HeroSliderManagement/HeroSliderList/HeroSliderList";
import UpdateHeroSlider from "./pages/HomeManagement/HeroSliderManagement/UpdateHeroSlider/UpdateHeroSlider";
import AddPartner from "./pages/HomeManagement/PartnerManagement/AddPartner/AddPartner";
import PartnerList from "./pages/HomeManagement/PartnerManagement/PartnerList/PartnerList";
import UpdatePartner from "./pages/HomeManagement/PartnerManagement/UpdatePartner/UpdatePartner";
import AddTestimonial from "./pages/HomeManagement/TestimonialManagement/AddTestimonial/AddTestimonial";
import TestimonialList from "./pages/HomeManagement/TestimonialManagement/TestimonialList/TestimonialList";
import UpdateTestimonial from "./pages/HomeManagement/TestimonialManagement/UpdateTestimonial/UpdateTestimonial";
import AddFooter from "./pages/HomeManagement/FooterManagement/Addfooter/Addfooter";
import FooterList from "./pages/HomeManagement/FooterManagement/footerList/footerList";
import UpdateFooter from "./pages/HomeManagement/FooterManagement/Updatefooter/Updatefooter";

import CommissionlistManagement from "./pages/CommissionManagement/CommissionlistManagement/CommissionlistManagement";

import AddUserPolicy from "./pages/UserPolicy/AddUserPolicy/AddUserPolicy";
import UpdateUserPolicy from "./pages/UserPolicy/UpdateUserPolicy/UpdateUserPolicy";

import UserPolicyListbyAgent from "./pages/UserPolicybyAgent/UserPolicyListbyAgent/UserPolicyListbyAgent";

import FeedbackList from "./pages/FeedbackList/FeedbackList";

import FinalReport from "./pages/FinalReport/FinalReport";

import HelpAndSupportCategoryList from "./pages/HelpAndSupport/HelpAndSupportCategoryList/HelpAndSupportCategoryList";
import HelpAndSupportList from "./pages/HelpAndSupport/HelpAndSupportList/HelpAndSupportList";
import UpdateHelpAndSupportCategory from "./pages/HelpAndSupport/UpdateHelpAndSupportCategory/UpdateHelpAndSupportCategory";
import AddHelpAndSupportCategory from "./pages/HelpAndSupport/AddHelpAndSupportCategory/AddHelpAndSupportCategory";
import AddHelpAndSupport from "./pages/HelpAndSupport/AddHelpAndSupport/AddHelpAndSupport";
import ChatReplyByAdmin from "./pages/HelpAndSupport/ChatReplyByAdmin/ChatReplyByAdmin";
import FollowupLeads from "./pages/InquiriesManagement/Followup/FollowupLeadslist.jsx";
import UserFollowupLeads from "./pages/InquiriesManagement/Followup/UserFollowupLeads";
import FollowupLeadHistory from "./pages/InquiriesManagement/Followup/FollowupLeadHistory";

import IpManagementlist from "./pages/IpManagement/IpManagementlist/IpManagementlist";
import Addip from "./pages/IpManagement/AddIP/Addip.jsx";
import AddAgentRole from "./pages/RoleManagement/AddAgentRole/AddAgentRole";
import HomeVisitsLead from "./pages/InquiriesManagement/HomeVisitsLead/HomeVisitsLead";
import Rewardlist from "./pages/Reward/RewardList/RewardlList.jsx";
import RewardList from "./pages/Reward/RewardList/RewardlList.jsx";
import AddReward from "./pages/Reward/AddReward/AddReward.jsx";
import RewardPointsList from "./pages/Reward/RewardPoints/RewardPointsList/RewardPointsList.jsx";
import CommissionList from "./pages/CommissionManagement/commissionManagementdata/CommissionList/CommissionList.jsx";
import AddCommission from "./pages/CommissionManagement/commissionManagementdata/AddCommission/AddCommission.jsx";
import AddCommissionRule from "./pages/CommissionManagement/AddCommissionRule/AddCommissionRule.jsx";
import CommissionRuleList from "./pages/CommissionManagement/CommissionRuleList/CommissionRuleList.jsx";
import ProjectSetting from "./pages/ProjectSetting/ProjectSettingList/ProjectSettingList.jsx";
import VoucherList from "./pages/Voucher/VoucherList/VoucherLsit.jsx";
import EmployeeLogin from "./pages/EmployeeLogin/EmployeeLogin.jsx";
import DesignationList from "./pages/Designation/DesigntionList/DesignationList.jsx";
import AddDesignation from "./pages/Designation/CreateDesignation/CreateDesignation.jsx";
import GalleryList from "./pages/GalleryManagement/GalleryList/GalleryList";
import AddGallery from "./pages/GalleryManagement/AddGallery/AddGallery";
import UpdateGallery from "./pages/GalleryManagement/UpdateGallery/UpdateGallery";
import TeamMemberList from "./pages/TeamMemberManagement/TeamMemberList/TeamMemberList";
import AddTeamMember from "./pages/TeamMemberManagement/AddTeamMember/AddTeamMember";
import UpdateTeamMember from "./pages/TeamMemberManagement/UpdateTeamMember/UpdateTeamMember";
import NotificationList from "./pages/NotificationManagement/NotificationList/NotificationList";
import AddNotification from "./pages/NotificationManagement/AddNotification/AddNotification";
import ContactFormInquiry from "./pages/InquiriesManagement/ContactFormInquiry";
import PartnerFormInquiry from "./pages/InquiriesManagement/PartnerFormInquiry";
import EventTemplateList from "./pages/GoogleCalendar/EventTemplateList";
import HolidayCalendar from "./pages/GoogleCalendar/HolidayCalendar";
import GreetingCardCalendar from "./pages/GreetingCardManagement/GreetingCardCalendar";
import GreetingCardList from "./pages/GreetingCardManagement/GreetingCardList";
import XOXODashboard from "./pages/XOXODashboard/XOXODashboard";
import XOXOOrderHistory from "./pages/XOXOOrderHistory/XOXOOrderHistory";
import XOXOPaymentHistory from "./pages/XOXOPaymentHistory/XOXOPaymentHistory";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("InsuranceAdminToken");

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("InsuranceAdminToken");

  return !isAuthenticated ? children : <Navigate to="/home" replace />;
};

const MainLayout = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  );
};

function App() {
  return (
    <>
      <Routes>
        <Route
          path="/admin"
          element={
            <PublicRoute>
              <Loginpage />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <PublicRoute>
              <EmployeeLogin />
            </PublicRoute>
          }
        />
        <Route path="/employee-login" element={<EmployeeLogin />} />

        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/home" element={<WelcomeDashboard />} />
          <Route path="/dashboard" element={<HomeComponent />} />
          <Route path="/welcome" element={<WelcomeDashboard />} />

          {/* user details */}

          <Route path="/user-management" element={<UserManagementList />} />
          <Route path="/user-details" element={<UserDetails />} />
          <Route
            path="/manage-delete-requests"
            element={<ManageDeleteRequests />}
          />
          <Route
            path="/delete-requests/assign-agent/:requestId"
            element={<AssignAgentPage />}
          />

          <Route
            path="/inquiries-management"
            element={<InquiriesManagement />}
          />
          <Route
            path="/update-inquiries-management"
            element={<UpdateInquiriesManagement />}
          />
          <Route path="/all-enquiries" element={<Allenquiries />} />
          <Route
            path="/contact-form-inquiry"
            element={<ContactFormInquiry />}
          />
          <Route
            path="/partner-form-inquiry"
            element={<PartnerFormInquiry />}
          />
          <Route path="/agent-meeting-lead" element={<AgentMeetingLead />} />
          <Route path="/add-booking" element={<AddBooking />} />
          <Route
            path="/booking-management-list"
            element={<BookingManagementList />}
          />
          <Route path="/subcategory-list" element={<SubCategorylist />} />
          <Route path="/add-subcategory" element={<AddSubcategory />} />
          <Route path="/update-subcategory" element={<UpdateSubcategory />} />
          <Route path="/subcategory-details" element={<SubCategoryDetails />} />
          <Route path="/category-list" element={<CategoryList />} />
          <Route path="/add-category" element={<AddCategory />} />
          <Route path="/update-category" element={<UpdateCategory />} />
          {/* Gallery Management Routes */}
          <Route path="/gallery-list" element={<GalleryList />} />
          <Route path="/add-gallery" element={<AddGallery />} />
          <Route path="/update-gallery" element={<UpdateGallery />} />

          {/* Team Member Management Routes */}
          <Route path="/team-member-list" element={<TeamMemberList />} />
          <Route path="/add-team-member" element={<AddTeamMember />} />
          <Route path="/update-team-member" element={<UpdateTeamMember />} />

          <Route path="/role-list" element={<RoleManagementList />} />
          <Route path="/add-role" element={<AddRole />} />
          <Route path="/agent-role" element={<AddAgentRole />} />
          <Route path="/update-role" element={<UpdateRole />} />
          <Route path="/setting" element={<SettingManagement />} />

          {/* Company Management Routes */}
          <Route
            path="/add-vehicle-manufacturers-company"
            element={<AddVehicleManufacturersCompany />}
          />
          <Route
            path="/vehicle-manufacturers-company-list"
            element={<VehicleManufacturersCompanyList />}
          />
          <Route
            path="/update-vehicle-manufacturers-company"
            element={<UpdateVehicleManufacturersCompany />}
          />

          {/* Company category Management Routes */}
          <Route path="/add-employee" element={<AddEmployee />} />
          <Route path="/employee-list" element={<EmployeeList />} />
          <Route path="/update-employee" element={<UpdateEmployee />} />

          {/* Company subcategory Management Routes */}
          <Route
            path="/add-manufacturers-company-subcategory"
            element={<ManufacturersAddCompanySubCategory />}
          />
          <Route
            path="/manufacturers-company-subcategory-list"
            element={<ManufacturersCompanySubCategorylist />}
          />
          <Route
            path="/update-manufacturers-company-subcategory"
            element={<UpdateManufacturersCompanySubCategory />}
          />

          {/* Header Management Routes */}

          <Route path="/header-list" element={<HeaderList />} />
          <Route path="/update-header" element={<UpdateHeader />} />
          <Route path="/add-header" element={<AddHeader />} />

          {/* Hero Slider Management Routes */}
          <Route path="/add-hero-slide" element={<AddHeroSlider />} />
          <Route path="/hero-slider-list" element={<HeroSliderList />} />
          <Route path="/update-hero-slide" element={<UpdateHeroSlider />} />

          {/* Partner Management Routes */}
          <Route path="/add-partner" element={<AddPartner />} />
          <Route path="/partner-list" element={<PartnerList />} />
          <Route path="/update-partner" element={<UpdatePartner />} />

          {/* Testimonial Management Routes */}
          <Route path="/add-testimonial" element={<AddTestimonial />} />
          <Route path="/testimonial-list" element={<TestimonialList />} />
          <Route path="/update-testimonial" element={<UpdateTestimonial />} />

          {/* Footer Management Routes */}
          <Route path="/add-footer" element={<AddFooter />} />
          <Route path="/footer-list" element={<FooterList />} />
          <Route path="/update-footer" element={<UpdateFooter />} />

          {/* Holiday Calendar Routes */}
          <Route path="/holiday-calendar" element={<HolidayCalendar />} />
          <Route path="/event-templates" element={<EventTemplateList />} />

          {/* Greeting Card Management Routes */}

          <Route
            path="/greeting-card-calendar"
            element={<GreetingCardCalendar />}
          />
          <Route path="/greeting-card-list" element={<GreetingCardList />} />

          {/* Order Management Routes */}
          <Route
            path="/commission-list"
            element={<CommissionlistManagement />}
          />

          {/* User Policy Management Routes */}
          <Route path="/add-user-policy" element={<AddUserPolicy />} />
          <Route path="/update-user-policy" element={<UpdateUserPolicy />} />
          <Route
            path="/user-policy-list-by-agent"
            element={<UserPolicyListbyAgent />}
          />

          <Route path="/feedback-list" element={<FeedbackList />} />

          <Route path="/final-report" element={<FinalReport />} />

          {/* reward */}
          <Route path="/reward-list" element={<RewardList />} />
          <Route path="/add-reward" element={<AddReward />} />
          <Route path="/reward-points" element={<RewardPointsList />} />

          {/* followup leads */}
          <Route path="/followup-leads" element={<FollowupLeads />} />
          <Route
            path="/user-followup-leads/:userId"
            element={<UserFollowupLeads />}
          />
          <Route
            path="/followup-leads/history"
            element={<FollowupLeadHistory />}
          />

          {/* Help and Support Routes */}
          <Route
            path="/help-and-support-category-list"
            element={<HelpAndSupportCategoryList />}
          />
          <Route
            path="/help-and-support-list"
            element={<HelpAndSupportList />}
          />
          <Route
            path="/add-help-and-support-category"
            element={<AddHelpAndSupportCategory />}
          />
          <Route
            path="/update-help-and-support-category"
            element={<UpdateHelpAndSupportCategory />}
          />
          <Route path="/add-help-and-support" element={<AddHelpAndSupport />} />
          <Route path="/chat-reply-by-admin" element={<ChatReplyByAdmin />} />
          <Route path="/home-visits-lead" element={<HomeVisitsLead />} />

          {/* commission management */}

          <Route path="/commission-lists" element={<CommissionList />} />
          <Route path="/add-commission" element={<AddCommission />} />
          <Route
            path="/commission-rule-list"
            element={<CommissionRuleList />}
          />
          <Route path="/add-commission-rule" element={<AddCommissionRule />} />

          <Route path="/project-setting" element={<ProjectSetting />} />

          {/* ip management  */}

          <Route path="/ip-list" element={<IpManagementlist />} />
          <Route path="/add-ip" element={<Addip />} />

          {/* admin profile */}

          <Route path="/csv-lead-list" element={<CSVLeadList />} />
          <Route path="/add-csv" element={<AddCSV />} />

          <Route path="/admin-profile" element={<AdminProfile />} />
          <Route path="/voucherlist" element={<VoucherList />} />
          <Route path="/designation-list" element={<DesignationList />} />
          <Route path="/designation-add" element={<AddDesignation />} />

          {/* XOXO Dashboard Routes */}
          <Route path="/xoxo-dashboard" element={<XOXODashboard />} />
          <Route path="/xoxo-order-history" element={<XOXOOrderHistory />} />
          <Route
            path="/xoxo-payment-history"
            element={<XOXOPaymentHistory />}
          />
        </Route>
      </Routes>

      {/* <Header/>
      <Sidebar/>
      <HomeComponent/>
      <Footer/> */}
    </>
  );
}

export default App;
